import React from 'react';
import Button from '@mui/material/Button';
import GetAppIcon from '@mui/icons-material/GetApp';
import { parse as convertFromCSV } from 'papaparse';

const ImportButton = props => {
  const { onParseData } = props;

  const handleChange = e => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      convertFromCSV(file, {
        delimiter: ',',
        complete: (result) => {
          const { data } = result;

          const keys = data[0];
          const choiceKeyIndex = keys.indexOf("choices");

          let prevIndex = 0;
          const values = {};
          data.slice(1).forEach((row, rowIndex) => {

            const value = { choices: [] };
            if (row[0] === "") {
              values[prevIndex]['choices'].push({txt: row[choiceKeyIndex]});
            } else {
              keys.forEach((key, index) => {
                if (key === "choices") {
                  value.choices.push({txt: row[index]});
                } else if(["correctAnswer", "languageTag"].includes(key)){
                  value[key] = row[index].split(";");
                }else{
                  value[key] = row[index];
                }
              });
              values[rowIndex] = value;
              prevIndex = rowIndex;
            }

          });
          onParseData(values);
        }
      });
    }
  };

  return (
    <>
      <input
        type="file"
        id="text-button-file"
        style={{ display: 'none' }}
        accept='.csv'
        onChange={handleChange}
      />
      <label htmlFor="text-button-file" style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Button
          color="primary"
          component="span"
        >
          <GetAppIcon style={{ transform: 'rotate(180deg)', fontSize: 20 }} />
          <span style={{ paddingLeft: '0.5em' }}>Import</span>
        </Button>
      </label>
    </>
  );
};

export default ImportButton;